<!-- eslint-disable vue/no-unused-vars -->
<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('pageDayRateEditor.rateEditor') }}
    </portal>
    <!--    <card cols="12" title="Debug">-->
    <!--      <hm-col cols="12">-->
    <!--        <pre v-html="seasonDates" />-->
    <!--      </hm-col>-->
    <!--    </card>-->
    <card :title="$t('pageDayRateEditor.rateEditor')" cols="12">
      <hm-card-inner>
        <hm-input-date v-model="startDate"
                       :min-date="$moment(minDate, 'YYYYMMDD').add(-1, 'days').format('YYYYMMDD')"
                       :max-date="$moment(maxDate, 'YYYYMMDD').add(-days, 'days').format('YYYYMMDD')"
                       :label="$t('pageDayRateEditor.startDate')"
                       cols="12 2@tablet 2@desktop 1@hd"
                       name="startDate" />
        <hm-input-select v-model="days"
                         :label="$t('pageDayRateEditor.numberOfDays')"
                         name="days"
                         cols="12 2@tablet 2@desktop 1@hd">
          <option :value="7">8</option>
          <option :value="14">15</option>
          <option :value="21">22</option>
          <option :value="28">29</option>
          <option v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :value="40">40 🔒</option>
          <option v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :value="80">80 🔒</option>
          <option v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :value="120">120 🔒</option>
        </hm-input-select>
      </hm-card-inner>
      <hm-card-inner :title="$t('pageDayRateOverview.card.filter')">
        <hm-multiselect v-model="filterRoomTypes"
                        :label="$t('pageDayRateOverview.filterRoomTypes')"
                        :options="unfilteredRoomTypes"
                        :limit="3"
                        label-expression="${option.name[$shortLocale]}"
                        cols="start-1 12 6@tablet"
                        name="filterRoomTypes">
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-tooltip="{ title: $t('pageDayRateOverview.unselectAll'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="close"
                               @click="filterRoomTypes = []" />
            <input-icon-button v-tooltip="{ title: $t('pageDayRateOverview.selectAll'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="select-all"
                               @click="filterRoomTypes = hotelSettings.roomTypes.all().map(it => it.id)" />
          </template>
        </hm-multiselect>
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <div class="daily-rate-editor__pane">
            <div class="daily-rate-editor__left">
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <template v-for="roomType in roomTypes">
                <div :key="roomType.id" :title="roomType.name[hotelSettings.details.primaryLanguage]" class="daily-rate-editor__roomType" @click="toggleRoomType(roomType.id)">
                  <icon :class="[{'daily-rate-editor__icon--open': openRoomTypes[roomType.id]}]" class="daily-rate-editor__icon" icon="collapse" /> {{ roomType.name[hotelSettings.details.primaryLanguage] }} <span v-if="!isEmpty(roomType.parentRoomTypeId)" class="text--regular hidden visible@desktop">&nbsp;(derived)</span>
                </div>
                <template v-if="openRoomTypes[roomType.id]">
                  <div class="daily-rate-editor__label">{{ $t('pageDayRateEditor.available') }}</div>
                  <template v-if="isEmpty(roomType.parentRoomTypeId)">
                    <!-- Occupancy Rates -->
                    <div class="daily-rate-editor__label daily-rate-editor__label--sub-heading" @click="toggleOccupancyRates(roomType.id)">
                      <icon :class="[{'daily-rate-editor__icon--open': openOccupancyRates[roomType.id]}]" class="daily-rate-editor__icon" icon="collapse" />{{ $t('pageDayRateEditor.occupancyRates') }}
                    </div>
                    <template v-if="openOccupancyRates[roomType.id]">
                      <template v-for="numPersons in intArray(roomType.maxOccupancy - roomType.minOccupancy + 1, roomType.minOccupancy)">
                        <div class="daily-rate-editor__label__wrapper">
                          <div class="daily-rate-editor__label daily-rate-editor__label--2"><icon class="daily-rate-editor__icon" icon="per-person" />&nbsp;x&nbsp;{{ numPersons }}<template v-if="numPersons === roomType.expectedOccupancy">&nbsp;<span :title="$t('pageDayRateEditor.defaultOccupancy')" style="display:block;overflow: hidden;text-overflow: ellipsis;min-width: 0;">{{ $t('pageDayRateEditor.defaultOccupancy') }}</span></template></div>
                          <div class="daily-rate-editor__label--right">{{ hotelSettings.details.currency }}</div>
                        </div>
                      </template>
                    </template>
                    <template v-if="isEmpty(ratePlan.parentRatePlanId)">
                      <!-- Additional Persons -->
                      <div class="daily-rate-editor__label daily-rate-editor__label--sub-heading" @click="toggleAdditionalPersons(roomType.id)">
                        <icon :class="[{'daily-rate-editor__icon--open': openAdditionalPersons[roomType.id]}]" class="daily-rate-editor__icon" icon="collapse" />{{ $t('pageDayRateEditor.additionalPersonRates') }}
                      </div>
                      <template v-if="openAdditionalPersons[roomType.id]">
                        <div class="daily-rate-editor__label__wrapper">
                          <div :title="$t('pageDayRateEditor.extraAdultRate')" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.extraAdultRate') }}</div>
                          <div class="daily-rate-editor__label--right">{{ hotelSettings.details.currency }}</div>
                        </div>
                        <div class="daily-rate-editor__label__wrapper">
                          <div :title="$t('pageDayRateEditor.fewerAdultRate')" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.fewerAdultRate') }}</div>
                          <div class="daily-rate-editor__label--right">{{ hotelSettings.details.currency }}</div>
                        </div>
                        <div :title="$t('pageDayRateEditor.minAdultsForChildRate')" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.minAdultsForChildRate') }}</div>
                        <template v-for="ageCategory in hotelSettings.ageCategories.all()" v-if="!ageCategory.deleted && ageCategory.ageFrom >= 0">
                          <div class="daily-rate-editor__label__wrapper">
                            <div class="daily-rate-editor__label daily-rate-editor__label--2">{{ ageCategory.name[hotelSettings.details.primaryLanguage] }} ({{ ageCategory.ageFrom }} - {{ ageCategory.ageUntil }})</div>
                            <div class="daily-rate-editor__label--right">{{ hotelSettings.details.currency }}</div>
                          </div>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <!-- Derived Rate Overrides -->
                      <div class="daily-rate-editor__label daily-rate-editor__label--sub-heading" @click="toggleDerivedRateOffsets(roomType.id)">
                        <icon :class="[{'daily-rate-editor__icon--open': openDerivedRateOffsets[roomType.id]}]" class="daily-rate-editor__icon" icon="collapse" />{{ $t('pageDayRateEditor.derivedRateOffsets') }}
                      </div>
                      <template v-if="openDerivedRateOffsets[roomType.id]">
                        <div class="daily-rate-editor__label__wrapper">
                          <div class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.adult') }}</div>
                          <div class="daily-rate-editor__label--right">± {{ hotelSettings.details.currency }}</div>
                        </div>
                        <template v-for="ageCategory in hotelSettings.ageCategories.all()" v-if="!ageCategory.deleted && ageCategory.ageFrom >= 0">
                          <div class="daily-rate-editor__label__wrapper">
                            <div class="daily-rate-editor__label daily-rate-editor__label--2">{{ ageCategory.name[hotelSettings.details.primaryLanguage] }} ({{ ageCategory.ageFrom }} - {{ ageCategory.ageUntil }})</div>
                            <div class="daily-rate-editor__label--right">± {{ hotelSettings.details.currency }}</div>
                          </div>
                        </template>
                        <div class="daily-rate-editor__label__wrapper">
                          <div class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.roomPercentage') }}</div>
                          <div class="daily-rate-editor__label--right">± %</div>
                        </div>
                        <div class="daily-rate-editor__label__wrapper">
                          <div class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.roomAmount') }}</div>
                          <div class="daily-rate-editor__label--right">± {{ hotelSettings.details.currency }}</div>
                        </div>
                      </template>
                    </template>
                    <!-- Restrictions -->
                    <div class="daily-rate-editor__label daily-rate-editor__label--sub-heading" @click="toggleRoomTypeRestrictions(roomType.id)">
                      <icon :class="[{'daily-rate-editor__icon--open': openRestrictions[roomType.id]}]" class="daily-rate-editor__icon" icon="collapse" />{{ $t('pageDayRateEditor.restrictions') }}
                    </div>
                    <template v-if="openRestrictions[roomType.id]">
                      <div class="daily-rate-editor__label daily-rate-editor__label--2">MinLOS</div>
                      <div class="daily-rate-editor__label daily-rate-editor__label--2">MaxLOS</div>
                      <div v-tooltip="{ title: $t('pageDayRateEditor.minStayThroughTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">MinStayThrough</div>
                      <div v-tooltip="{ title: $t('pageDayRateEditor.maxStayThroughTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">MaxStayThrough</div>
                      <div v-tooltip="{ title: $t('pageDayRateEditor.closedTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.closed') }}</div>
                      <div v-tooltip="{ title: $t('pageDayRateEditor.closedArrivalTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.closedArrival') }}</div>
                      <div v-tooltip="{ title: $t('pageDayRateEditor.closedDepartureTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.closedDeparture') }}</div>
                      <template v-if="hasLicense('LeadTimeToBook')">
                        <div v-tooltip="{ title: $t('pageDayRateEditor.minLeadTimeToBookTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.minLeadTimeToBook') }}</div>
                        <div v-tooltip="{ title: $t('pageDayRateEditor.maxLeadTimeToBookTooltip'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: true }" class="daily-rate-editor__label daily-rate-editor__label--2">{{ $t('pageDayRateEditor.maxLeadTimeToBook') }}</div>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </div>
            <div class="daily-rate-editor__scroll">
              <div :style="`--days: ${Math.min(dates.length)}`" class="daily-rate-editor__wrapper">
                <div v-tooltip="{ title: (seasonDates[date] || {}).name || '-', delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                     v-for="date in dates"
                     :key="`season-${date}`"
                     :title="(seasonDates[date] || {}).name || '-'"
                     :style="`background: ${(seasonDates[date] || {}).color || '#fff'}`"
                     class="daily-rate-editor__season"></div>
                <div v-for="date in dates"
                     :class="[
                       {'daily-rate-editor__date--weekend': isWeekend(date)},
                       {'in-selection': date >= selectionStartDate && date <= selectionEndDate },
                       {'daily-rate-editor__date--inline-editing': inlineEditing }
                     ]"
                     class="daily-rate-editor__date"
                     @click="onClickDate(date)"
                     @mousedown="onMouseDown(date)"
                     @mouseenter="onMouseMove(date)"
                     @mouseup="onMouseUp(date)">
                  <span>{{ date | dayOfWeek }}</span>
                  <span>{{ date | date }}</span>
                  <span>{{ date | month }}</span>
                  <span>{{ date | year }}</span>
                </div>
                <template v-for="roomType in roomTypes">
                  <div v-for="date in dates" :class="[{'daily-rate-editor__placeholder--weekend': isWeekend(date)}]" class="daily-rate-editor__placeholder"></div>
                  <template v-if="openRoomTypes[roomType.id] && !isEmpty(roomType.data)">
                    <!-- Availability -->
                    <template v-for="availability in getRoomTypeAvailability(roomType.id)">
                      <div :class="[{'color--red': availability < 0}]" class="daily-rate-editor__value text--bold">
                        {{ availability }}
                      </div>
                    </template>
                    <template v-if="isEmpty(roomType.parentRoomTypeId)">
                      <!-- Occupancy Rates -->
                      <div v-for="date in dates" class="daily-rate-editor__value">
                      </div>
                      <template v-if="openOccupancyRates[roomType.id]">
                        <template v-for="numPersons in intArray(roomType.maxOccupancy - roomType.minOccupancy + 1, roomType.minOccupancy)">
                          <template v-for="date in roomType.data">
                            <template v-if="isEmpty(ratePlan.parentRatePlanId)">
                              <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'occupancyRate' && currentEdit.param1 === numPersons">
                                <hm-input-daily-rate-editor :key="`occupancyRate-${roomType.id}-${ratePlan.id}-${date.date}-${numPersons}`"
                                                            :complete-inline-editing="completeInlineEditing"
                                                            :current-edit="currentEdit"/>
                              </template>
                              <template v-else>
                                <div v-if="!isNil(date.occupancyRate[numPersons])"
                                     :class="[getErrorFareClass(roomType, date, numPersons), { 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                     class="daily-rate-editor__value"
                                     @click="editInline(ratePlan, roomType, date, 'occupancyRate', numPersons)">
                                  <span >{{ date.occupancyRate[numPersons] | toCurrency }}</span>
                                  <span v-if="date.occupancyRate[numPersons] != getRate(roomType, date, numPersons)" class="daily-rate-editor__inherited-value">{{ getRate(roomType, date, numPersons) | toCurrency }}</span>
                                </div>
                                <div v-else-if="!isNil(getRate(roomType, date, numPersons))"
                                     :class="[getErrorFareClass(roomType, date, numPersons), { 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                     class="daily-rate-editor__value daily-rate-editor__value--auto"
                                     @click="editInline(ratePlan, roomType, date, 'occupancyRate', numPersons)">
                                  <span >{{ getRate(roomType, date, numPersons) | toCurrency }}</span>
                                </div>
                                <div v-else
                                     :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                     class="daily-rate-editor__value"
                                     @click="editInline(ratePlan, roomType, date, 'occupancyRate', numPersons)">
                                  <span >-</span>
                                </div>
                              </template>
                            </template>
                            <template v-else>
                              <div v-if="!isNil(date.occupancyRate[numPersons])"
                                   :class="[getErrorFareClass(roomType, date, numPersons)]"
                                   class="daily-rate-editor__value  daily-rate-editor__value--auto">
                                <span >{{ date.occupancyRate[numPersons] | toCurrency }}</span>
                              </div>
                              <div v-else class="daily-rate-editor__value">
                                <span>-</span>
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                      <template v-if="isEmpty(ratePlan.parentRatePlanId)">
                        <!-- Additional Person Rates -->
                        <div v-for="date in dates" class="daily-rate-editor__value">
                        </div>
                        <template v-if="openAdditionalPersons[roomType.id]">
                          <template v-for="date in roomType.data">
                            <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'extraAdultRate'">
                              <hm-input-daily-rate-editor :key="`extraAdultRate-${roomType.id}-${ratePlan.id}-${date.date}`"
                                                          :complete-inline-editing="completeInlineEditing"
                                                          :current-edit="currentEdit"/>
                            </template>
                            <div v-else
                                 :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                 class="daily-rate-editor__value"
                                 @click="editInline(ratePlan, roomType, date, 'extraAdultRate')">
                              <span>{{ (isNil(date.extraAdultRate) ? '-' : date.extraAdultRate) | toCurrency }}</span>
                            </div>
                          </template>
                          <template v-for="date in roomType.data">
                            <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'fewerAdultRate'">
                              <hm-input-daily-rate-editor :key="`fewerAdultRate-${roomType.id}-${ratePlan.id}-${date.date}`"
                                                          :complete-inline-editing="completeInlineEditing"
                                                          :current-edit="currentEdit"/>
                            </template>
                            <div v-else
                                 :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                 class="daily-rate-editor__value"
                                 @click="editInline(ratePlan, roomType, date, 'fewerAdultRate')">
                              <span>{{ (isNil(date.fewerAdultRate) ? '-' : date.fewerAdultRate) | toCurrency }}</span>
                            </div>
                          </template>
                          <div v-for="date in roomType.data" class="daily-rate-editor__value">
                            <span>{{ date.minAdultsForChildRate || '-' }}</span>
                          </div>
                          <template v-for="ageCategory in hotelSettings.ageCategories.all()" v-if="!ageCategory.deleted && ageCategory.ageFrom >= 0">
                            <template v-for="date in roomType.data">
                              <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'childCategoryRate' && currentEdit.param1 === ageCategory.id">
                                <hm-input-daily-rate-editor :key="`childCategoryRate-${roomType.id}-${ratePlan.id}-${date.date}-${ageCategory.id}`"
                                                            :complete-inline-editing="completeInlineEditing"
                                                            :current-edit="currentEdit"/>
                              </template>
                              <div v-else
                                   :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                   class="daily-rate-editor__value"
                                   @click="editInline(ratePlan, roomType, date, 'childCategoryRate', ageCategory.id)">
                                <span>{{ isNil(date.childCategoryRate) ? '-' : (isNil(date.childCategoryRate[ageCategory.id]) ? '-' : date.childCategoryRate[ageCategory.id]) | toCurrency }}</span>
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <!-- Derived Rate Overrides -->
                        <div v-for="date in dates" class="daily-rate-editor__value">
                        </div>
                        <template v-if="openDerivedRateOffsets[roomType.id]">
                          <template v-for="date in roomType.data">
                            <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'rateOffsets' && currentEdit.param1 === 'perAdultOffset'">
                              <hm-input-daily-rate-editor :key="`perAdultOffset-${roomType.id}-${ratePlan.id}-${date.date}`"
                                                          :complete-inline-editing="completeInlineEditing"
                                                          :current-edit="currentEdit"/>
                            </template>
                            <div v-else
                                 :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                 class="daily-rate-editor__value"
                                 @click="editInline(ratePlan, roomType, date, 'rateOffsets', 'perAdultOffset')">
                              <span>{{ (isNil(date.rateOffsets) ? '-' : (date.rateOffsets.perAdultOffset || '-')) | toCurrency }}</span>
                            </div>
                          </template>
                          <template v-for="ageCategory in hotelSettings.ageCategories.all()" v-if="!ageCategory.deleted && ageCategory.ageFrom >= 0">
                            <template v-for="date in roomType.data">
                              <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'childCategoryOffset' && currentEdit.param1 === ageCategory.id">
                                <hm-input-daily-rate-editor :key="`childCategoryOffset-${roomType.id}-${ratePlan.id}-${date.date}-${ageCategory.id}`"
                                                            :complete-inline-editing="completeInlineEditing"
                                                            :current-edit="currentEdit"/>
                              </template>
                              <div v-else
                                   :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                   class="daily-rate-editor__value"
                                   @click="editInline(ratePlan, roomType, date, 'childCategoryOffset', ageCategory.id)">
                                <span>{{ (isNil(date.rateOffsets) ? '-' : (isNil(date.rateOffsets.childCategoryOffset) ? '-' : (date.rateOffsets.childCategoryOffset[ageCategory.id] || '-'))) | toCurrency }}</span>
                              </div>
                            </template>
                          </template>
                          <template v-for="date in roomType.data">
                            <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'rateOffsets' && currentEdit.param1 === 'roomOffsetPercentage'">
                              <hm-input-daily-rate-editor :key="`roomOffsetPercentage-${roomType.id}-${ratePlan.id}-${date.date}`"
                                                          :complete-inline-editing="completeInlineEditing"
                                                          :current-edit="currentEdit"/>
                            </template>
                            <div v-else
                                 :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                 class="daily-rate-editor__value"
                                 @click="editInline(ratePlan, roomType, date, 'rateOffsets', 'roomOffsetPercentage')">
                              <span>{{ (isNil(date.rateOffsets) ? '-' : (date.rateOffsets.roomOffsetPercentage || '-')) | toCurrency }}</span>
                            </div>
                          </template>
                          <template v-for="date in roomType.data">
                            <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'rateOffsets' && currentEdit.param1 === 'roomOffsetAmount'">
                              <hm-input-daily-rate-editor :key="`roomOffsetAmount-${roomType.id}-${ratePlan.id}-${date.date}`"
                                                          :complete-inline-editing="completeInlineEditing"
                                                          :current-edit="currentEdit"/>
                            </template>
                            <div v-else
                                 :class="{ 'daily-rate-editor__value--inline-editing': inlineEditing }"
                                 class="daily-rate-editor__value"
                                 @click="editInline(ratePlan, roomType, date, 'rateOffsets', 'roomOffsetAmount')">
                              <span>{{ (isNil(date.rateOffsets) ? '-' : (date.rateOffsets.roomOffsetAmount || '-')) | toCurrency }}</span>
                            </div>
                          </template>
                        </template>
                      </template>
                      <!-- Restriction Heading Line -->
                      <div v-for="date in dates" class="daily-rate-editor__value">
                      </div>
                      <template v-if="openRestrictions[roomType.id]">
                        <!--                      <div v-for="date in roomType.data" class="daily-rate-editor__value daily-rate-editor__value&#45;&#45;inherited">-->
                        <!--                        <span>{{ date.restrictions.minLOS || '-' }}</span>-->
                        <!--                        <span class="daily-rate-editor__inherited-value">77</span>-->
                        <!--                      </div>-->
                        <template v-for="date in roomType.data">
                          <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'MinLOS'">
                            <hm-input-daily-rate-editor :key="`occupancyRate-${roomType.id}-${ratePlan.id}-${date.date}-minLOS`"
                                                        :class="[{'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)}]"
                                                        :complete-inline-editing="completeInlineEditing"
                                                        :fraction-digits="0"
                                                        :current-edit="currentEdit">
                              <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MinLOS') || '-' }}</span>
                            </hm-input-daily-rate-editor>
                          </template>
                          <div v-else
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.minLOS) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minLOS)}]"
                               class="daily-rate-editor__value">
                            <span :class="[{ 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                  @click="editInline(ratePlan, roomType, date, 'MinLOS')">
                              {{ getValue(ratePlan, roomType, date, 'MinLOS') || '-' }}
                            </span>
                            <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MinLOS') || '-' }}</span>
                          </div>
                        </template>
                        <template v-for="date in roomType.data">
                          <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'MaxLOS'">
                            <hm-input-daily-rate-editor :key="`occupancyRate-${roomType.id}-${ratePlan.id}-${date.date}-maxLOS`"
                                                        :class="[{'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)}]"
                                                        :complete-inline-editing="completeInlineEditing"
                                                        :fraction-digits="0"
                                                        :current-edit="currentEdit">
                              <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MaxLOS') || '-' }}</span>
                            </hm-input-daily-rate-editor>
                          </template>
                          <div v-else
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.maxLOS) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.maxLOS)},
                                 {'daily-rate-editor__value--auto': ratePlan.ratePlanType === 'Package' && isNil(date.restrictions.maxLOS) && (isNil(date.parentRestrictions) || isNil(date.parentRestrictions.maxLOS)) && (!isNil(date.restrictions.minLOS) || (!isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minLOS)))}]"
                               class="daily-rate-editor__value">
                            <span :class="[{ 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                  @click="editInline(ratePlan, roomType, date, 'MaxLOS')">
                              {{ coalesce(getValue(ratePlan, roomType, date, 'MaxLOS'), '-') }}
                            </span>
                            <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ coalesce(getParentValue(ratePlan, roomType, date, 'MaxLOS'), '-') }}</span>
                          </div>
                        </template>
                        <template v-for="date in roomType.data">
                          <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'MinStayThrough'">
                            <hm-input-daily-rate-editor :key="`occupancyRate-${roomType.id}-${ratePlan.id}-${date.date}-MinStayThrough`"
                                                        :class="[{'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)}]"
                                                        :complete-inline-editing="completeInlineEditing"
                                                        :fraction-digits="0"
                                                        :current-edit="currentEdit">
                              <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MinStayThrough') || '-' }}</span>
                            </hm-input-daily-rate-editor>
                          </template>
                          <div v-else
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.minStayThrough) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minStayThrough)}]"
                               class="daily-rate-editor__value">
                            <span :class="[{ 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                  @click="editInline(ratePlan, roomType, date, 'MinStayThrough')">
                              {{ getValue(ratePlan, roomType, date, 'MinStayThrough') || '-' }}
                            </span>
                            <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MinStayThrough') || '-' }}</span>
                          </div>
                        </template>
                        <template v-for="date in roomType.data">
                          <template v-if="currentEdit.active && currentEdit.ratePlanId === ratePlan.id && currentEdit.roomTypeId === roomType.id && currentEdit.date === date.date && currentEdit.type === 'MaxStayThrough'">
                            <hm-input-daily-rate-editor :key="`occupancyRate-${roomType.id}-${ratePlan.id}-${date.date}-MaxStayThrough`"
                                                        :class="[{'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)}]"
                                                        :complete-inline-editing="completeInlineEditing"
                                                        :fraction-digits="0"
                                                        :current-edit="currentEdit">
                              <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ getParentValue(ratePlan, roomType, date, 'MaxStayThrough') || '-' }}</span>
                            </hm-input-daily-rate-editor>
                          </template>
                          <div v-else
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.maxStayThrough) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.maxStayThrough)},
                                 {'daily-rate-editor__value--auto': ratePlan.ratePlanType === 'Package' && isNil(date.restrictions.maxStayThrough) && (isNil(date.parentRestrictions) || isNil(date.parentRestrictions.maxStayThrough)) && (!isNil(date.restrictions.minStayThrough) || (!isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minStayThrough)))}]"
                               class="daily-rate-editor__value">
                            <span :class="[{ 'daily-rate-editor__value--inline-editing': inlineEditing }]"
                                  @click="editInline(ratePlan, roomType, date, 'MaxStayThrough')">
                              {{ coalesce(getValue(ratePlan, roomType, date, 'MaxStayThrough'), '-') }}
                            </span>
                            <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ coalesce(getParentValue(ratePlan, roomType, date, 'MaxStayThrough'), '-') }}</span>
                          </div>
                        </template>
                        <div v-for="date in roomType.data"
                             :class="[
                               {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                               {'daily-rate-editor__value--auto': isNil(date.restrictions.bookable) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.bookable)},
                               {'daily-rate-editor__value--inherited daily-rate-editor__value--auto': noSeasonDates.includes(date.date)}]"
                             class="daily-rate-editor__value">
                          <template v-if="noSeasonDates.includes(date.date)">
                            <span>1<template v-if="!isNil(date.restrictions.bookable)">&nbsp;({{ date.restrictions.bookable === false ? '1' : '0' }})</template></span>
                            <span class="daily-rate-editor__inherited-value">no season</span>
                          </template>
                          <template v-else>
                            <span v-if="date.restrictions.bookable === false">1</span>
                            <span v-else-if="date.restrictions.bookable === true">0</span>
                            <span v-else>{{ isNil(date.parentRestrictions) ? '1' : (date.parentRestrictions.bookable ? '0' : '1') }}</span>
                            <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ isNil(date.parentRestrictions) ? '1' : (date.parentRestrictions.bookable ? '0' : '1') }}</span>
                          </template>
                        </div>
                        <div v-for="date in roomType.data"
                             :class="[
                               {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                               {'daily-rate-editor__value--auto': isNil(date.restrictions.closedArrival) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.closedArrival)}]"
                             class="daily-rate-editor__value">
                          <span v-if="date.restrictions.closedArrival === false">0</span>
                          <span v-else-if="date.restrictions.closedArrival === true">1</span>
                          <span v-else>{{ (isNil(date.parentRestrictions) ? '0' : (date.parentRestrictions.closedArrival ? '1' : '0')) }}</span>
                          <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ isNil(date.parentRestrictions) ? '1' : (date.parentRestrictions.closedArrival ? '1' : '0') }}</span>
                        </div>
                        <div v-for="date in roomType.data"
                             :class="[
                               {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                               {'daily-rate-editor__value--auto': isNil(date.restrictions.closedDeparture) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.closedDeparture)}]"
                             class="daily-rate-editor__value">
                          <span v-if="date.restrictions.closedDeparture === false">0</span>
                          <span v-else-if="date.restrictions.closedDeparture === true">1</span>
                          <span v-else>{{ (isNil(date.parentRestrictions) ? '0' : (date.parentRestrictions.closedDeparture ? '1' : '0')) }}</span>
                          <span v-if="!isEmpty(ratePlan.parentRatePlanId)" class="daily-rate-editor__inherited-value">{{ isNil(date.parentRestrictions) ? '1' : (date.parentRestrictions.closedDeparture ? '1' : '0') }}</span>
                        </div>
                        <template v-if="hasLicense('LeadTimeToBook')">
                          <div v-for="date in roomType.data"
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.minLeadTimeToBook) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minLeadTimeToBook)}]"
                               class="daily-rate-editor__value">
                            <span>{{ $t(`LeadTimePeriodShort.${getValue(ratePlan, roomType, date, 'MinimumLeadTimeToBook') || '-' }`) }}</span>
                          </div>
                          <div v-for="date in roomType.data"
                               :class="[
                                 {'daily-rate-editor__value--inherited': !isEmpty(ratePlan.parentRatePlanId)},
                                 {'daily-rate-editor__value--auto': isNil(date.restrictions.maxLeadTimeToBook) && !isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.maxLeadTimeToBook)}]"
                               class="daily-rate-editor__value">
                            <span>{{ $t(`LeadTimePeriodShort.${getValue(ratePlan, roomType, date, 'MaximumLeadTimeToBook') || '-' }`) }}</span>
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-col cols="12 6@tablet 4@desktop 3@hd" class="daily-rate-editor__legend__item">
          <div class="daily-rate-editor__legend daily-rate-editor__legend--auto"/>
          <div class="daily-rate-editor__legend__label">{{ $t('pageDayRateEditor.calculatedValue') }}</div>
        </hm-col>
        <hm-col cols="12 6@tablet 4@desktop 3@hd" class="daily-rate-editor__legend__item">
          <div class="daily-rate-editor__legend daily-rate-editor__legend--warn"/>
          <div class="daily-rate-editor__legend__label">{{ $t('pageDayRateEditor.potentialError') }}</div>
        </hm-col>
        <hm-col cols="12 6@tablet 4@desktop 3@hd" class="daily-rate-editor__legend__item">
          <div class="daily-rate-editor__legend daily-rate-editor__legend--error"/>
          <div class="daily-rate-editor__legend__label">{{ $t('pageDayRateEditor.errorFare') }}</div>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="!isEmpty(ratePlan.parentRatePlanId)" :title="$t('pageDayRateEditor.derviedRateOffsetCalculation')">
        <hm-col cols="12">
          <span class="text-block text-block--small text-block--info col-12">
            {{ $t('pageDayRateEditor.rateCalculationLine1') }}<br />
            {{ $t('pageDayRateEditor.rateCalculationLine2') }}
          </span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-input-toggle v-model="inlineEditing"
                         :label="$t('pageDayRateEditor.inlineEditing')"
                         :enabled-title="$t('pageDayRateEditor.inlineEditingEnabled')"
                         :disabled-title="$t('pageDayRateEditor.inlineEditingDisabled')"
                         cols="12 4@tablet 3@desktop 2@hd" />
      </hm-card-inner>
    </card>

    <modal v-if="showUpdateModal"
           :hide-on-submit="false"
           :close-on-click-outside="false"
           :button2-disabled="() => isEmpty(update.roomTypeId)"
           :title="$t('pageDayRateEditor.rateRestrictionUpdate')"
           @confirm="sendUpdate"
           @cancel="showUpdateModal=false">
      <hm-card-inner min-height="12.6rem">
        <hm-multiselect v-model="update.roomTypeId"
                        :options="updateRoomTypes"
                        :label="$t('pageDayRateEditor.roomTypes')"
                        cols="12"
                        label-expression="${option.name[$shortLocale]} (${option.minOccupancy} - ${option.maxOccupancy})"
                        style="z-index: 15"
                        @focus="onFocusRoomTypes"
                        @blur="onBlurRoomTypes" >
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-tooltip="{ title: $t('pageDayRateOverview.unselectAll'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="close"
                               @click="update.roomTypeId = []" />
            <input-icon-button v-tooltip="{ title: $t('pageDayRateOverview.selectAll'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="select-all"
                               @click="update.roomTypeId = hotelSettings.roomTypes.all().map(it => it.id)" />
          </template>
        </hm-multiselect>
        <template>
          <hm-input-date ref="startDate"
                         v-model="update.startDate"
                         :label="$t('pageDayRateEditor.from')"
                         cols="6"
                         name="startDate" />
          <hm-input-date ref="endDate"
                         v-model="update.endDate"
                         :min-date="update.startDate"
                         :min-date-inclusive="true"
                         :max-days="730"
                         :max-date="maxDate"
                         :auto-adjust="false"
                         :label="$t('pageDayRateEditor.until')"
                         cols="6"
                         name="endDate" />
        </template>
      </hm-card-inner>
      <hm-card-inner :title="$t('pageDayRateEditor.updateDaysOfWeek')">
        <hm-col :grid="true" cols="12" style="--column-count:7;--column-width:20px;margin-bottom: 1.6rem;margin-top: 0.8rem;" class="grid--column-count">
          <template v-for="i in 7">
            <hm-input-checkbox v-model="update.daysOfWeek[i-1]"
                               :label="getWeekdayLabel(i - 1)"
                               :name="`daysOfWeek${i}`"
                               :key="i"
                               :show-label="true"
                               cols="1"/>
          </template>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="isEmpty(ratePlan.parentRatePlanId)"
                     :disabled="isEmpty(update.roomTypeId)"
                     :collapse-locked="collapseLocked || Object.values(update.updates.occupancy).some(it => it.update)"
                     :open="Object.values(update.updates.occupancy).some(it => it.update)"
                     :title="$t('pageDayRateEditor.occupancyRates')"
                     style="z-index: 0;"
                     collapsible>
        <template v-if="!selectedUpdateRoomTypesEqualOccupancy">
          <hm-col cols="12">
            <span class="info-text info-text--full-size col-12">{{ $t('pageDayRateEditor.occupancyRatesCanOnlyBeUpdatedIfRoomTypesOccupancyIsEqual') }}</span>
          </hm-col>
        </template>
        <template v-else>
          <template v-if="(update.roomTypeId || []).length > 1">
            <hm-col cols="12">
              <span class="info-text info-text--full-size col-12">{{ $t('pageDayRateEditor.occupancyRatesNoteUpdatingMultipleRoomTypes') }}</span>
            </hm-col>
          </template>
          <template v-for="(value, numPersons) in update.updates.occupancy">
            <hm-input-toggle id="update"
                             v-model="value.update"
                             :key="`update-${numPersons}`"
                             :label="$t('pageDayRateEditor.update')"
                             :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                             :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                             cols="4"
                             name="update" />
            <hm-input-money v-model="value.amount"
                            :key="`rate-${numPersons}`"
                            :disabled="!value.update"
                            :currency="hotelSettings.details.currency"
                            :label="$t('pageDayRateEditor.pax', [numPersons])"
                            name="amount"
                            cols="8" />
          </template>
        </template>
      </hm-card-inner>
      <hm-card-inner v-if="isEmpty(ratePlan.parentRatePlanId)"
                     :collapse-locked="collapseLocked || update.updates.extraAdult.update || update.updates.minAdultsForChildRate.update || Object.values(update.updates.childRate).some(it => it.update)"
                     :disabled="isEmpty(update.roomTypeId)"
                     :title="$t('pageDayRateEditor.additionalPersonRates')"
                     :open="update.updates.extraAdult.update || update.updates.minAdultsForChildRate.update || Object.values(update.updates.childRate).some(it => it.update)"
                     style="z-index: 0;"
                     collapsible>
        <hm-input-toggle id="update"
                         v-model="update.updates.extraAdult.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-money v-model="update.updates.extraAdult.amount"
                        :disabled="!update.updates.extraAdult.update"
                        :currency="hotelSettings.details.currency"
                        :label="$t('pageDayRateEditor.extraAdultRate')"
                        name="amount"
                        cols="8" />
        <hm-input-toggle id="update"
                         v-model="update.updates.fewerAdult.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-money v-model="update.updates.fewerAdult.amount"
                        :disabled="!update.updates.fewerAdult.update"
                        :currency="hotelSettings.details.currency"
                        :label="$t('pageDayRateEditor.fewerAdultRate')"
                        name="amount"
                        cols="8" />
        <hm-input-toggle id="update"
                         v-model="update.updates.minAdultsForChildRate.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-number v-model="update.updates.minAdultsForChildRate.count"
                         :disabled="!update.updates.minAdultsForChildRate.update"
                         :validate="`min_value: 0`"
                         :label="$t('pageDayRateEditor.minAdultsForChildRate')"
                         name="amount"
                         cols="8" />
        <template v-for="(value, acId) in update.updates.childRate">
          <hm-input-toggle id="update"
                           v-model="value.update"
                           :key="`update-${acId}`"
                           :label="$t('pageDayRateEditor.update')"
                           :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                           :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                           cols="4"
                           name="update" />
          <hm-input-money v-model="value.amount"
                          :key="`rate-${acId}`"
                          :disabled="!value.update"
                          :currency="hotelSettings.details.currency"
                          :label="`${findHotelSettingById('ageCategories', acId).name[hotelSettings.details.primaryLanguage]} (${findHotelSettingById('ageCategories', acId).ageFrom} - ${findHotelSettingById('ageCategories', acId).ageUntil})`"
                          name="amount"
                          cols="8" />
        </template>
      </hm-card-inner>
      <hm-card-inner v-if="!isEmpty(ratePlan.parentRatePlanId)"
                     :collapse-locked="collapseLocked || update.updates.derivedRateOffsets.adultOffset.update || Object.values(update.updates.derivedRateOffsets.childCategoryOffset).some(it => it.update) || update.updates.derivedRateOffsets.roomOffsetPercentage.update || update.updates.derivedRateOffsets.roomOffsetAmount.update"
                     :disabled="isEmpty(update.roomTypeId)"
                     :title="$t('pageDayRateEditor.derivedRateOffsets')"
                     :open="update.updates.derivedRateOffsets.adultOffset.update || Object.values(update.updates.derivedRateOffsets.childCategoryOffset).some(it => it.update) || update.updates.derivedRateOffsets.roomOffsetPercentage.update || update.updates.derivedRateOffsets.roomOffsetAmount.update"
                     style="z-index: 0;"
                     collapsible>
        <hm-input-toggle id="update"
                         v-model="update.updates.derivedRateOffsets.adultOffset.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-money v-model="update.updates.derivedRateOffsets.adultOffset.amount"
                        :disabled="!update.updates.derivedRateOffsets.adultOffset.update"
                        :currency="hotelSettings.details.currency"
                        :label="$t('pageDayRateEditor.perAdultOffset')"
                        name="amount"
                        cols="8">
          <template slot="icon-inline-left" slot-scope="slot">
            <input-icon-button disabled border icon="plus"/>
          </template>
        </hm-input-money>

        <template v-for="(value, acId) in update.updates.derivedRateOffsets.childCategoryOffset">
          <hm-input-toggle id="update"
                           v-model="value.update"
                           :key="`update-${acId}`"
                           :label="$t('pageDayRateEditor.update')"
                           :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                           :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                           cols="4"
                           name="update" />
          <hm-input-money v-model="value.amount"
                          :key="`rate-${acId}`"
                          :disabled="!value.update"
                          :currency="hotelSettings.details.currency"
                          :label="`${findHotelSettingById('ageCategories', acId).name[hotelSettings.details.primaryLanguage]} (${findHotelSettingById('ageCategories', acId).ageFrom} - ${findHotelSettingById('ageCategories', acId).ageUntil})`"
                          name="amount"
                          cols="8">
            <template slot="icon-inline-left" slot-scope="slot">
              <input-icon-button disabled border icon="plus"/>
            </template>
          </hm-input-money>
        </template>

        <hm-input-toggle id="update"
                         v-model="update.updates.derivedRateOffsets.roomOffsetPercentage.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-money v-model="update.updates.derivedRateOffsets.roomOffsetPercentage.amount"
                        :disabled="!update.updates.derivedRateOffsets.roomOffsetPercentage.update"
                        :validate="`min_value:-100`"
                        :label="$t('pageDayRateEditor.roomPercentage')"
                        currency="%"
                        name="percentage"
                        cols="8">
          <template slot="icon-inline-left" slot-scope="slot">
            <input-icon-button disabled border icon="plus"/>
          </template>
        </hm-input-money>

        <hm-input-toggle id="update"
                         v-model="update.updates.derivedRateOffsets.roomOffsetAmount.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-money v-model="update.updates.derivedRateOffsets.roomOffsetAmount.amount"
                        :disabled="!update.updates.derivedRateOffsets.roomOffsetAmount.update"
                        :currency="hotelSettings.details.currency"
                        :label="$t('pageDayRateEditor.roomAmount')"
                        name="amount"
                        cols="8">
          <template slot="icon-inline-left" slot-scope="slot">
            <input-icon-button disabled border icon="plus"/>
          </template>
        </hm-input-money>
      </hm-card-inner>
      <hm-card-inner :disabled="isEmpty(update.roomTypeId)"
                     :collapse-locked="collapseLocked || Object.values(update.updates.restriction).some(it => it.update)"
                     :title="$t('pageDayRateEditor.restrictions')"
                     :open="Object.values(update.updates.restriction).some(it => it.update)"
                     style="z-index: 0;"
                     collapsible>
        <hm-input-toggle v-model="update.updates.restriction.minLOS.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-number v-model="update.updates.restriction.minLOS.value"
                         :validate="`max_value:${update.updates.restriction.maxLOS.value || 365}|min_value:1`"
                         :disabled="!update.updates.restriction.minLOS.update"
                         label="MinLOS"
                         name="minLOS"
                         cols="8" />
        <hm-input-toggle v-model="update.updates.restriction.maxLOS.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-number v-model="update.updates.restriction.maxLOS.value"
                         :validate="`min_value:${update.updates.restriction.minLOS.value || 1}|max_value:365`"
                         :disabled="!update.updates.restriction.maxLOS.update"
                         label="MaxLOS"
                         name="maxLOS"
                         cols="8" />
        <hm-input-toggle v-model="update.updates.restriction.minStayThrough.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-number v-model="update.updates.restriction.minStayThrough.value"
                         :validate="`min_value:1|max_value:365`"
                         :disabled="!update.updates.restriction.minStayThrough.update"
                         label="MinStayThrough"
                         name="minStayThrough"
                         cols="8" />
        <hm-input-toggle v-model="update.updates.restriction.maxStayThrough.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-number v-model="update.updates.restriction.maxStayThrough.value"
                         :validate="`min_value:${update.updates.restriction.maxStayThrough.value || 1}|max_value:365`"
                         :disabled="!update.updates.restriction.maxStayThrough.update"
                         label="MaxStayThrough"
                         name="maxStayThrough"
                         cols="8" />
        <hm-input-toggle v-model="update.updates.restriction.closed.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-toggle v-if="isEmpty(ratePlan.parentRatePlanId)"
                         v-model="update.updates.restriction.closed.value"
                         :disabled="!update.updates.restriction.closed.update"
                         :label="$t('pageDayRateEditor.closed')"
                         :enabled-title="$t('pageDayRateEditor.closedEnabled')"
                         :disabled-title="$t('pageDayRateEditor.closedDisabled')"
                         cols="8"
                         name="closed" />
        <hm-tristate v-else
                     v-model="update.updates.restriction.closed.value"
                     :disabled="!update.updates.restriction.closed.update"
                     :label="$t('pageDayRateEditor.closed')"
                     cols="8"
                     name="closed" />
        <hm-input-toggle v-model="update.updates.restriction.closedArrival.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-toggle v-if="isEmpty(ratePlan.parentRatePlanId)"
                         v-model="update.updates.restriction.closedArrival.value"
                         :disabled="!update.updates.restriction.closedArrival.update"
                         :label="$t('pageDayRateEditor.closedArrival')"
                         :enabled-title="$t('pageDayRateEditor.closedArrivalEnabled')"
                         :disabled-title="$t('pageDayRateEditor.closedArrivalDisabled')"
                         cols="8"
                         name="closedArrival" />
        <hm-tristate v-else
                     v-model="update.updates.restriction.closedArrival.value"
                     :disabled="!update.updates.restriction.closedArrival.update"
                     :label="$t('pageDayRateEditor.closedArrival')"
                     cols="8"
                     name="closed" />
        <hm-input-toggle v-model="update.updates.restriction.closedDeparture.update"
                         :label="$t('pageDayRateEditor.update')"
                         :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                         :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                         cols="4"
                         name="update" />
        <hm-input-toggle v-if="isEmpty(ratePlan.parentRatePlanId)"
                         v-model="update.updates.restriction.closedDeparture.value"
                         :disabled="!update.updates.restriction.closedDeparture.update"
                         :label="$t('pageDayRateEditor.closedDeparture')"
                         :enabled-title="$t('pageDayRateEditor.closedDepartureEnabled')"
                         :disabled-title="$t('pageDayRateEditor.closedDepartureDisabled')"
                         cols="8"
                         name="closedDeparture" />
        <hm-tristate v-else
                     v-model="update.updates.restriction.closedDeparture.value"
                     :disabled="!update.updates.restriction.closedDeparture.update"
                     :label="$t('pageDayRateEditor.closedDeparture')"
                     cols="8"
                     name="closed" />
        <template v-if="hasLicense('LeadTimeToBook')">
          <hm-input-toggle v-model="update.updates.restriction.minLeadTimeToBook.update"
                           :label="$t('pageDayRateEditor.update')"
                           :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                           :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                           cols="4"
                           name="update" />
          <hm-input-select v-model="update.updates.restriction.minLeadTimeToBook.value"
                           :disabled="!update.updates.restriction.minLeadTimeToBook.update"
                           :help="$t('pageDayRateEditor.minLeadTimeToBookTooltip')"
                           label="MinLeadTimeToBook"
                           name="minLeadTimeToBook"
                           cols="8">
            <option :value="null"></option>
            <option value="PT0S">{{ $t("LeadTimePeriod.PT0S") }}</option>
            <option value="PT2H">{{ $t("LeadTimePeriod.PT2H") }}</option>
            <option value="PT4H">{{ $t("LeadTimePeriod.PT4H") }}</option>
            <option value="PT6H">{{ $t("LeadTimePeriod.PT6H") }}</option>
            <option value="PT9H">{{ $t("LeadTimePeriod.PT9H") }}</option>
            <option value="P1D">{{ $t("LeadTimePeriod.P1D") }}</option>
            <option value="P2D">{{ $t("LeadTimePeriod.P2D") }}</option>
            <option value="P3D">{{ $t("LeadTimePeriod.P3D") }}</option>
            <option value="P4D">{{ $t("LeadTimePeriod.P4D") }}</option>
            <option value="P5D">{{ $t("LeadTimePeriod.P5D") }}</option>
            <option value="P6D">{{ $t("LeadTimePeriod.P6D") }}</option>
            <option value="P1W">{{ $t("LeadTimePeriod.P1W") }}</option>
            <option value="P2W">{{ $t("LeadTimePeriod.P2W") }}</option>
            <option value="P3W">{{ $t("LeadTimePeriod.P3W") }}</option>
            <option value="P1M">{{ $t("LeadTimePeriod.P1M") }}</option>
            <option value="P2M">{{ $t("LeadTimePeriod.P2M") }}</option>
            <option value="P3M">{{ $t("LeadTimePeriod.P3M") }}</option>
            <option value="P4M">{{ $t("LeadTimePeriod.P4M") }}</option>
            <option value="P5M">{{ $t("LeadTimePeriod.P5M") }}</option>
            <option value="P6M">{{ $t("LeadTimePeriod.P6M") }}</option>
            <option value="P1Y">{{ $t("LeadTimePeriod.P1Y") }}</option>
          </hm-input-select>
          <hm-input-toggle v-model="update.updates.restriction.maxLeadTimeToBook.update"
                           :label="$t('pageDayRateEditor.update')"
                           :enabled-title="$t('pageDayRateEditor.updateEnabled')"
                           :disabled-title="$t('pageDayRateEditor.updateDisabled')"
                           cols="4"
                           name="update" />
          <hm-input-select v-model="update.updates.restriction.maxLeadTimeToBook.value"
                           :disabled="!update.updates.restriction.maxLeadTimeToBook.update"
                           :help="$t('pageDayRateEditor.maxLeadTimeToBookTooltip')"
                           label="MaxLeadTimeToBook"
                           name="maxLeadTimeToBook"
                           cols="8">
            <option :value="null"></option>
            <option value="PT2H">{{ $t("LeadTimePeriod.PT2H") }}</option>
            <option value="PT4H">{{ $t("LeadTimePeriod.PT4H") }}</option>
            <option value="PT6H">{{ $t("LeadTimePeriod.PT6H") }}</option>
            <option value="PT9H">{{ $t("LeadTimePeriod.PT9H") }}</option>
            <option value="P1D">{{ $t("LeadTimePeriod.P1D") }}</option>
            <option value="P2D">{{ $t("LeadTimePeriod.P2D") }}</option>
            <option value="P3D">{{ $t("LeadTimePeriod.P3D") }}</option>
            <option value="P4D">{{ $t("LeadTimePeriod.P4D") }}</option>
            <option value="P5D">{{ $t("LeadTimePeriod.P5D") }}</option>
            <option value="P6D">{{ $t("LeadTimePeriod.P6D") }}</option>
            <option value="P1W">{{ $t("LeadTimePeriod.P1W") }}</option>
            <option value="P2W">{{ $t("LeadTimePeriod.P2W") }}</option>
            <option value="P3W">{{ $t("LeadTimePeriod.P3W") }}</option>
            <option value="P1M">{{ $t("LeadTimePeriod.P1M") }}</option>
            <option value="P2M">{{ $t("LeadTimePeriod.P2M") }}</option>
            <option value="P3M">{{ $t("LeadTimePeriod.P3M") }}</option>
            <option value="P4M">{{ $t("LeadTimePeriod.P4M") }}</option>
            <option value="P5M">{{ $t("LeadTimePeriod.P5M") }}</option>
            <option value="P6M">{{ $t("LeadTimePeriod.P6M") }}</option>
            <option value="P1Y">{{ $t("LeadTimePeriod.P1Y") }}</option>
          </hm-input-select>
        </template>
      </hm-card-inner>
    </modal>

    <spinner-overlay v-if="saving || loading" />


    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :label="$t('pageDayRateEditor.updateRatesAndRestrictions')"
                          icon="edit"
                          color="orange"
                          @click="onClickOpenModal" />
    </hm-floating-buttons>
  </main>
</template>

<!-- https://www.hotellinksolutions.com/occupancy-based-pricing-hotel-link/ -->

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, debounce, find, findIndex, isArray, isEmpty, isNil, keyBy, map, sortBy, uniq } from 'lodash';
import HmCol from '../../lib/layout/HmCol';
import HmCardInner from '../../lib/layout/HmCardInner';
import Modal from '../../lib/util/Modal';
import PageMixin from '../../../mixins/PageMixin';
import FilterMixin from '../../../mixins/FilterMixin';
import HmTristate from '../../lib/inputs/HmTriState';
import TimerMixin from '../../../mixins/TimerMixin';
import HmMultiselect from '../../lib/inputs/HmMultiselect';
import HmInputNumber from '../../lib/inputs/HmInputNumber.vue';
import UserConfigMixin from '../../../mixins/UserConfigMixin';
import HmInputDailyRateEditor from '../../lib/inputs/HmInputDailyRateEditor.vue';
import fecha from 'fecha';

export default {
  name: 'PageDayRateEditor',
  components: { HmInputDailyRateEditor, HmInputNumber, HmMultiselect, HmCol, HmTristate, Modal, HmCardInner },
  filters: {
    dayOfWeek(data) {
      return new Intl.DateTimeFormat(window.i18n.locale, { weekday: 'short' }).format(
        new Date(`${data.substring(0, 4)}-${data.substring(5, 7)}-${data.substring(8, 10)}`),
      );
    },
    date(data) {
      return parseInt(data.substring(8, 10), 10);
    },
    month(data) {
      const month = data.substring(5, 7);
      return new Intl.DateTimeFormat(window.i18n.locale, { month: 'short' }).format(
        new Date(Date.UTC(2023, parseInt(month, 10) - 1, 1)),
      );
    },
    year(data) {
      return data.substring(0, 4);
    },
  },

  mixins: [HotelmeisterMixin, PageMixin, FilterMixin, TimerMixin, UserConfigMixin],

  data() {
    return {
      dateSelection: {
        startDate: null,
        endDate: null,
        timeout: null,
      },
      collapseLocked: false,
      leftHeight: 0,
      saving: false,
      savesRemaining: 0,
      saveInterval: 0,
      loading: false,
      ratePlan: null,
      startDate: null,
      days: null,
      data: null,
      roomTypeAvailability: null,
      openRoomTypes: {},
      openRestrictions: {},
      openAdditionalPersons: {},
      openOccupancyRates: {},
      openDerivedRateOffsets: {},
      showUpdateModal: false,
      noSeasonDates: [],
      seasonDates: {},
      filterRoomTypes: [],
      update: {
        startDate: null,
        endDate: null,
        roomTypeId: [],
        daysOfWeek: [true, true, true, true, true, true, true],
        updates: {
          occupancy: {
          },
          extraAdult: {
            update: false,
            amount: null,
          },
          fewerAdult: {
            update: false,
            amount: null,
          },
          minAdultsForChildRate: {
            update: false,
            count: null,
          },
          childRate: {
          },
          derivedRateOffsets: {
            roomOffsetAmount: {
              update: false,
              type: 'RoomOffsetAmount',
              amount: null,
            },
            roomOffsetPercentage: {
              update: false,
              type: 'RoomOffsetPercentage',
              amount: null,
            },
            adultOffset: {
              update: false,
              type: 'AdultOffset',
              amount: null,
            },
            childCategoryOffset: {
            },
          },
          restriction: {
            minLOS: {
              update: false,
              restriction: 'MinLOS',
              value: null,
            },
            maxLOS: {
              update: false,
              restriction: 'MaxLOS',
              value: null,
            },
            minStayThrough: {
              update: false,
              restriction: 'MinStayThrough',
              value: null,
            },
            maxStayThrough: {
              update: false,
              restriction: 'MaxStayThrough',
              value: null,
            },
            closed: {
              update: false,
              restriction: 'Bookable',
              value: true, // inverted value
            },
            closedArrival: {
              update: false,
              restriction: 'ClosedArrival',
              value: true,
            },
            closedDeparture: {
              update: false,
              restriction: 'ClosedDeparture',
              value: true,
            },
            minLeadTimeToBook: {
              update: false,
              restriction: 'MinimumLeadTimeToBook',
              value: null,
            },
            maxLeadTimeToBook: {
              update: false,
              restriction: 'MaximumLeadTimeToBook',
              value: null,
            },
          },
        },
      },
      inlineEditing: false,
      currentEdit: {
        active: false,
        ratePlanId: null,
        roomTypeId: null,
        date: null,
        type: null,
        param1: null,
        param2: null,
        value: null,
      },
      inlineEditQueue: [],
    };
  },

  computed: {
    selectionStartDate: function () {
      if (isNil(this.dateSelection.startDate)) return 0;
      else return this.dateSelection.startDate; // this.$moment(this.dateSelection.startDate, 'YYYY-MM-DD');
    },
    selectionEndDate: function () {
      if (isNil(this.dateSelection.endDate)) return 0;
      else return this.dateSelection.endDate; // this.$moment(this.dateSelection.endDate, 'YYYY-MM-DD');
    },
    pageShortcuts: function () {
      return {
        'Ctrl+←': this.$t('pageRoomplan.shortcuts.moveBack'),
        'Ctrl+→': this.$t('pageRoomplan.shortcuts.moveForward'),
        'Ctrl+↓': this.$t('pageRoomplan.shortcuts.move1yBack'),
        'Ctrl+↑': this.$t('pageRoomplan.shortcuts.move1yForward'),
        'Ctrl+Pos1': this.$t('pageRoomplan.shortcuts.gotoToday'),
      };
    },
    updateMessage() {
      const ret = {
        startDate: this.update.startDate,
        endDate: this.update.endDate,
        roomTypeId: this.update.roomTypeId,
        daysOfWeek: this.update.daysOfWeek,
        occupancyRateUpdates: [],
        extraAdultRateUpdate: null,
        fewerAdultRateUpdate: null,
        minAdultsUpdate: null,
        dayRateOffsetUpdates: [],
        childRateUpdates: [],
        restrictionUpdates: [],
      };

      Object.entries(this.update.updates.occupancy).forEach((it) => {
        const key = it[0];
        const val = it[1];

        if (it[1].update) {
          ret.occupancyRateUpdates.push({
            occupancy: key,
            amount: it[1].amount,
          });
        }
      });

      if (this.update.updates.extraAdult.update) {
        ret.extraAdultRateUpdate = {
          amount: this.update.updates.extraAdult.amount,
        };
      }

      if (this.update.updates.fewerAdult.update) {
        ret.fewerAdultRateUpdate = {
          amount: this.update.updates.fewerAdult.amount,
        };
      }

      if (this.update.updates.minAdultsForChildRate.update) {
        ret.minAdultsUpdate = {
          count: this.update.updates.minAdultsForChildRate.count,
        };
      }

      Object.entries(this.update.updates.childRate).forEach((it) => {
        const key = it[0];
        const val = it[1];

        if (it[1].update) {
          ret.childRateUpdates.push({
            ageCategoryId: key,
            amount: it[1].amount,
          });
        }
      });

      Object.entries(this.update.updates.derivedRateOffsets).forEach((it) => {
        if (it[0] !== 'childCategoryOffset' && it[1].update) {
          ret.dayRateOffsetUpdates.push({
            type: it[1].type,
            amount: it[1].amount,
          });
        }
      });

      Object.entries(this.update.updates.derivedRateOffsets.childCategoryOffset).forEach((it) => {
        const key = it[0];
        const val = it[1];

        if (it[1].update) {
          ret.dayRateOffsetUpdates.push({
            id: key,
            amount: it[1].amount,
            type: 'ChildCategoryOffset',
          });
        }
      });

      Object.entries(this.update.updates.restriction).forEach((it) => {
        const key = it[0];
        const val = it[1];

        if (it[1].update) {
          ret.restrictionUpdates.push({
            restriction: it[1].restriction,
            value: !isNil(it[1].value) && it[1].restriction === 'Bookable' ? !it[1].value : it[1].value,
          });
        }
      });
      return ret;
    },
    today() {
      return this.$moment().format('YYYYMMDD');
    },
    maxDate() {
      return this.$moment().add(730, 'days').format('YYYYMMDD');
    },
    minDate() {
      return this.$moment('2023-01-01').format('YYYYMMDD');
    },
    ratePlanId: function () {
      return this.$route.params.ratePlanId;
    },
    endDate: function () {
      if (isNil(this.startDate)) return null;
      return this.$moment(this.startDate, 'YYYYMMDD').add(this.days, 'days').format('YYYYMMDD');
    },
    dates() {
      const dates = [];
      const currDate = this.$moment(this.startDate, 'YYYYMMDD');
      const lastDate = this.$moment(this.endDate, 'YYYYMMDD');
      const minDate = this.$moment(this.minDate, 'YYYYMMDD');
      const maxDate = this.$moment(this.maxDate, 'YYYYMMDD');

      dates.push(currDate.clone().format('YYYY-MM-DD'));
      while (currDate.add(1, 'days').diff(lastDate) <= 0) {
        // eslint-disable-next-line no-continue
        if (currDate.isBefore(minDate) || currDate.isAfter(maxDate)) continue;
        dates.push(currDate.clone().format('YYYY-MM-DD'));
      }

      return dates;
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    unfilteredRoomTypes: function () {
      if (isNil(this.ratePlan)) return [];
      const roomTypes = this.hotelSettings.roomTypes.all()
        .filter(it => isEmpty(this.ratePlan.applicableRoomTypes) || this.ratePlan.applicableRoomTypes.includes(it.id));

      return roomTypes;
    },
    roomTypes: function () {
      if (isNil(this.ratePlan)) return [];
      let roomTypes = this.unfilteredRoomTypes
        .filter(it => this.filterRoomTypes.includes(it.id));
        // .filter(roomType => isEmpty(roomType.parentRoomTypeId));

      roomTypes = cloneDeep(roomTypes);
      roomTypes.forEach((roomType) => {
        if (!isNil(this.data) && !isEmpty(this.data)) {
          roomType.data = sortBy(this.data.map(date => {
            let tmp = date.productRateMap.find(it => it[0].first === roomType.id && it[0].second === this.ratePlanId);
            if (!isNil(tmp) && isArray(tmp) && tmp.length >= 2) return tmp[1]
            else return null
          }), 'date');
        }
      });
      return roomTypes;
    },
    updateRoomTypes: function () {
      if (isNil(this.ratePlan)) return [];
      let roomTypes = this.hotelSettings.roomTypes.all()
        .filter(it => isEmpty(this.ratePlan.applicableRoomTypes) || this.ratePlan.applicableRoomTypes.includes(it.id))
        .filter(roomType => isEmpty(roomType.parentRoomTypeId));

      roomTypes = cloneDeep(roomTypes);
      roomTypes.forEach((roomType) => {
        if (!isNil(this.data) && !isEmpty(this.data)) {
          roomType.data = sortBy(this.data.map(date => date.productRateMap.find(it => it[0].first === roomType.id && it[0].second === this.ratePlanId)[1]), 'date');
        }
      });
      return roomTypes;
    },
    seasonMap: function () {
      return keyBy(this.hotelSettings.seasons.all(), 'id');
    },
    selectedUpdateRoomTypesEqualOccupancy() {
      return uniq(
        (this.updateRoomTypes || [])
          .filter(it => (this.update.roomTypeId || []).includes(it.id))
          .map(it => `${it.minOccupancy}/${it.expectedOccupancy}/${it.maxOccupancy}`),
      ).length === 1;
    },
  },

  watch: {
    filterRoomTypes: function (newVal, oldVal) {
      if (isNil(newVal)) return;
      if (newVal.length !== this.unfilteredRoomTypes.length) {
        if (Object.values(this.openRoomTypes).filter(it => it === true).length <= 1) {
          newVal.forEach((it) => {
            this.$set(this.openRoomTypes, it, true);
            this.$set(this.openOccupancyRates, it, true);
          });
        }
      }
    },
    inlineEditing: function () {
      this.setUserConfig('inlineEditing', this.inlineEditing);
    },
    openRoomTypes: {
      handler: function (newVal) {
        this.update.roomTypeId = Object.entries(newVal).filter(it => it[1]).map(it => it[0]) || [];
        // if (open.length === 1) {
        //   this.update.roomTypeId = [open[0][0]];
        // } else {
        //   this.update.roomTypeId = [];
        // }
      },
      deep: true,
    },
    startDate: function (newVal) {
      if (newVal < this.minDate) this.startDate = this.minDate;
      if (newVal > this.maxDate) this.startDate = this.maxDate;
      this.data = null;
      this.loadData();
      this.update.startDate = this.startDate;
    },
    endDate: function () {
      this.update.endDate = this.endDate;
    },
    days: function () {
      this.data = null;
      this.loadData();
    },
    'update.roomTypeId': function (newVal) {
      this.update.updates.occupancy = {};
      this.update.updates.extraAdult = {
        update: false,
        amount: null,
      };

      this.update.updates.minAdultsForChildRate = {
        update: false,
        count: null,
      };

      // if (!isNil(newVal) && newVal.length === 1) {
      if (!isNil(newVal) && newVal.length >= 1 && this.selectedUpdateRoomTypesEqualOccupancy) {
        const roomTypeId = newVal[0];

        if (!isEmpty(roomTypeId)) {
          const roomType = this.findHotelSettingById('roomTypes', roomTypeId);
          for (let i = roomType.minOccupancy; i <= roomType.maxOccupancy; i++) {
            this.$set(
              this.update.updates.occupancy,
              `${i}`,
              {
                update: false,
                amount: null,
              },
            );
          }
        }
      }

      this.update.updates.childRate = {};

      this.hotelSettings.ageCategories.all().filter(it => !it.deleted && it.ageFrom >= 0).forEach((it) => {
        this.$set(
          this.update.updates.childRate,
          `${it.id}`,
          {
            update: false,
            amount: null,
          },
        );

        this.$set(
          this.update.updates.derivedRateOffsets.childCategoryOffset,
          `${it.id}`,
          {
            id: it.id,
            type: 'ChildCategoryOffset',
            update: false,
            amount: null,
          },
        );
      });
    },
  },

  created: function () {
    this.inlineEditing = this.getUserConfig('inlineEditing') === 'true';
    this.ratePlan = this.findHotelSettingById('ratePlans', this.ratePlanId);

    if (this.ratePlan.rateEntryMode !== 'Daily') {
      this.$router.push({ name: 'seasonRateEditor' });
    }

    this.startDate = this.$moment().add(0, 'days').format('YYYYMMDD');

    try {
      this.days = Math.max(14, Math.floor((((Math.max(window.screen.availWidth, window.screen.availHeight) - 300 - 80) / 12 * 10) / (75 + 2)) / 7) * 7);
    } catch (_) {
      this.days = 21;
    }

    this.$serviceBus.$on('shortcut.pageRight', this.pageRight);
    this.$serviceBus.$on('shortcut.pageLeft', this.pageLeft);
    this.$serviceBus.$on('shortcut.pageUp', this.pageRightYear);
    this.$serviceBus.$on('shortcut.pageDown', this.pageLeftYear);
    this.$serviceBus.$on('shortcut.scrollTop', this.openToday);

    this.filterRoomTypes = this.unfilteredRoomTypes.map(it => it.id);

    this.loadData();
    this.loadSeasonData();

    // this.setInterval(() => {
    //   const $el = this.$el;
    //   if (!isNil($el)) {
    //     const left = $el.querySelector('.daily-rate-editor__left');
    //     if (!isNil(left)) this.leftHeight = left.clientHeight;
    //   }
    // }, 300);
  },

  updated() {
  },

  beforeDestroy() {
    this.$serviceBus.$off('shortcut.pageRight', this.pageRight);
    this.$serviceBus.$off('shortcut.pageLeft', this.pageLeft);
    this.$serviceBus.$off('shortcut.scrollTop', this.openToday);
    this.$serviceBus.$off('shortcut.pageUp', this.pageRightYear);
    this.$serviceBus.$off('shortcut.pageDown', this.pageLeftYear);
  },

  methods: {
    isEmpty,
    isNil,
    coalesce: function (...args) {
      console.log(args);
      console.log(find(args, val => !_.isNil(val) || val === 0));
      return find(args, val => !_.isNil(val) || val === 0);
    },
    openToday: function () {
      this.startDate = this.$moment().add(0, 'days').format('YYYYMMDD');
    },
    pageRight() {
      this.startDate = this.$moment(this.startDate, 'YYYYMMDD').add(this.days, 'days').format('YYYYMMDD');
    },
    pageLeft() {
      this.startDate = this.$moment(this.startDate, 'YYYYMMDD').add(-this.days, 'days').format('YYYYMMDD');
    },
    pageRightYear() {
      this.startDate = this.$moment(this.startDate, 'YYYYMMDD').add(1, 'year').format('YYYYMMDD');
    },
    pageLeftYear() {
      this.startDate = this.$moment(this.startDate, 'YYYYMMDD').add(-1, 'year').format('YYYYMMDD');
    },
    loadSeasonData() {
      const startDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD');
      const endDate = this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYY-MM-DD');

      this.axios.get(this.serviceUrls.seasonDate.list(this, startDate, endDate))
        .then((response) => {
          const lang = this.hotelSettings.details.primaryLanguage;
          this.seasonDates = {
            ...this.seasonDates,
            ...keyBy(response.data.data.map((it) => {
              const season = this.seasonMap[this.ratePlan.ratePlanType === 'DayRate' ? it.season : it.packageSeason];
              return {
                date: fecha.format(fecha.parse(it.date, 'YYYYMMDD'), 'YYYY-MM-DD'),
                id: (this.ratePlan.ratePlanType === 'DayRate' ? it.season : it.packageSeason),
                color: (season || {}).rgbColorCode,
                name: isNil(season) || isNil(season.name) || isEmpty(season.name[lang]) ? null : season.name[lang],
              };
            }), 'date'),
          };
        });
    },
    reloadDate: function (date) {
      if (isNil(this) || isEmpty(this.ratePlanId)) return; // can happen if the user left the page immediately after saving and the reload is triggered after the page has been left

      this.axios.get(this.serviceUrls.dailyRate.get(this, this.ratePlanId, date, 0))
        .then((response) => {
          response.data.data.forEach((itUpdate) => {
            const idx = findIndex(this.data, it => it.date === itUpdate.date);
            this.$set(this.data, idx, itUpdate);
          });
        });
    },
    loadData: debounce(
      function () {
        // can happen if the user left the page while loadData was triggered
        if (isNil(this) || isEmpty(this.ratePlanId)) return;

        this.loading = true;
        this.axios.get(this.serviceUrls.dailyRate.get(this, this.ratePlanId, this.startDate, this.days))
          .then((response) => {
            this.data = response.data.data;
          })
          .finally(() => {
            this.loading = false;
          });
        this.axios.get(this.serviceUrls.roomTypePlan(this), {
          params: {
            start: this.startDate,
            limit: this.days,
            cacheBuster: Math.floor(new Date() / 1000),
          },
          headers: {
            Accept: 'application/x-protobuf',
          },
          responseType: 'arraybuffer',
        }).then((response) => {
          this.roomTypeAvailability = response.data.data;
        });
        const isoStartDate = this.$moment(this.startDate, 'YYYYMMDD').format('YYYY-MM-DD');
        const isoEndDate = this.$moment(this.endDate, 'YYYYMMDD').format('YYYY-MM-DD');
        this.axios.get(this.serviceUrls.seasonDate.list(this, isoStartDate, isoEndDate))
          .then((response) => {
            this.noSeasonDates = response.data.data.map((it) => {
              const seasonId = this.ratePlan.ratePlanType === 'DayRate' ? it.season : it.packageSeason;
              return {
                date: it.date,
                seasonId: seasonId,
              };
            })
              .filter(it => isEmpty(it.seasonId))
              .map(it => it.date);
          });
      },
      100,
    ),
    toggleRoomType(roomTypeId) {
      if (isNil(this.openRoomTypes[roomTypeId])) this.$set(this.openRoomTypes, roomTypeId, true);
      else this.openRoomTypes[roomTypeId] = !this.openRoomTypes[roomTypeId];
      if (!this.openRoomTypes[roomTypeId] && this.openRestrictions[roomTypeId]) {
        this.openRestrictions[roomTypeId] = false;
      }
      if (!this.openRoomTypes[roomTypeId] && this.openAdditionalPersons[roomTypeId]) {
        this.openAdditionalPersons[roomTypeId] = false;
      }
      if (!this.openRoomTypes[roomTypeId] && this.openDerivedRateOffsets[roomTypeId]) {
        this.openDerivedRateOffsets[roomTypeId] = false;
      }
      this.$set(this.openOccupancyRates, roomTypeId, this.openRoomTypes[roomTypeId]);
    },
    toggleRoomTypeRestrictions(roomTypeId) {
      if (isNil(this.openRestrictions[roomTypeId])) this.$set(this.openRestrictions, roomTypeId, true);
      else this.openRestrictions[roomTypeId] = !this.openRestrictions[roomTypeId];
    },
    toggleAdditionalPersons(roomTypeId) {
      if (isNil(this.openAdditionalPersons[roomTypeId])) this.$set(this.openAdditionalPersons, roomTypeId, true);
      else this.openAdditionalPersons[roomTypeId] = !this.openAdditionalPersons[roomTypeId];
    },
    toggleOccupancyRates(roomTypeId) {
      if (isNil(this.openOccupancyRates[roomTypeId])) this.$set(this.openOccupancyRates, roomTypeId, true);
      else this.openOccupancyRates[roomTypeId] = !this.openOccupancyRates[roomTypeId];
    },
    toggleDerivedRateOffsets(roomTypeId) {
      if (isNil(this.openDerivedRateOffsets[roomTypeId])) this.$set(this.openDerivedRateOffsets, roomTypeId, true);
      else this.openDerivedRateOffsets[roomTypeId] = !this.openDerivedRateOffsets[roomTypeId];
    },
    intArray: function (value, offset = 0) {
      return [...Array(value).keys()].map(x => x + offset);
    },
    getRate(roomType, date, numPersons) {
      // Create a shallow copy of the occupancyRate object
      const occupancyRateCopy = { ...date.occupancyRate };

      // Backfill any gaps with the next higher occupancy rate
      let lastRate = null;

      for (let i = roomType.maxOccupancy; i >= roomType.minOccupancy; i--) {
        if (isNil(occupancyRateCopy[i]) && !isNil(lastRate)) {
          if (isNil(date.fewerAdultRate) || i >= roomType.expectedOccupancy) {
            occupancyRateCopy[i] = lastRate;
          } else {
            occupancyRateCopy[i] = lastRate - date.fewerAdultRate;
          }
        }
        lastRate = !isNil(occupancyRateCopy[i]) ? occupancyRateCopy[i] : lastRate
      }

      // Populate any missing elements with the extra adult rate
      lastRate = null;
      for (let i = roomType.minOccupancy; i <= roomType.maxOccupancy; i++) {
        if (isNil(occupancyRateCopy[i])) {
          if (isNil(lastRate)) {
            // Do nothing - in this case we can't calculate a rate
          } else if (isNil(date.extraAdultRate)) {
            occupancyRateCopy[i] = lastRate;
          } else {
            occupancyRateCopy[i] = lastRate + date.extraAdultRate;
          }
        }
        lastRate = !isNil(occupancyRateCopy[i]) ? occupancyRateCopy[i] : lastRate;
      }

      // Fix any rates where a higher occupancy rate is cheaper than a lower occupancy rate
      for (let i = roomType.minOccupancy; i < roomType.maxOccupancy; i++) {
        const currentRate = occupancyRateCopy[i];
        const nextRate = occupancyRateCopy[i + 1];

        if (!isNil(currentRate) && !isNil(nextRate) && nextRate < currentRate) {
          occupancyRateCopy[i + 1] = currentRate;
        }
      }

      // Remove any negative rate, replace them with the rate of the next higher occupancy
      for (let i = roomType.minOccupancy; i <= roomType.maxOccupancy; i++) {
        if (!isNil(occupancyRateCopy[i]) && occupancyRateCopy[i] < 0) {
          let j = i + 1;
          while (j <= roomType.maxOccupancy && (isNil(occupancyRateCopy[j]) || occupancyRateCopy[j] < 0)) {
            j++;
          }
          if (j <= roomType.maxOccupancy) {
            occupancyRateCopy[i] = occupancyRateCopy[j];
          } else {
            occupancyRateCopy[i] = occupancyRateCopy[i + 1];
          }
        }
      }

      return occupancyRateCopy[numPersons];
    },
    isWeekend(date) {
      return this.$moment(date).isoWeekday() >= 6;
    },
    getWeekdayLabel(weekdayNumber) { // 0 == Monday
      weekdayNumber += 1;
      if (weekdayNumber > 6) weekdayNumber -= 7;
      return this.$moment.localeData().weekdaysMin()[weekdayNumber]; // 0 = Sunday
    },
    sendUpdate() {
      if (isNil(this.updateMessage.roomTypeId)) return;
      if (this.updateMessage.occupancyRateUpdates.length === 0
            && this.updateMessage.childRateUpdates.length === 0
            && this.updateMessage.restrictionUpdates.length === 0
            && this.updateMessage.dayRateOffsetUpdates.length === 0
            && isNil(this.updateMessage.minAdultsUpdate)
            && isNil(this.updateMessage.extraAdultRateUpdate)
            && isNil(this.updateMessage.fewerAdultRateUpdate)) {
        this.showWarningMessage(this.$t('pageDayRateEditor.nothingToUpdate'));
        return;
      }

      if (this.saving) {
        this.$notify({
          group: 'msg',
          title: this.$t('app.saveInProgress.title'),
          text: this.$t('app.saveInProgress.text'),
          type: 'warn',
          duration: 3000,
        });
        return;
      }

      const updateMessages = cloneDeep(this.updateMessage);

      this.saving = true;

      const roomTypeIds = updateMessages.roomTypeId;
      const promises = [];

      updateMessages.roomTypeId = null;
      updateMessages.roomTypeIds = roomTypeIds;
      if (!this.selectedUpdateRoomTypesEqualOccupancy) {
        updateMessages.occupancyRateUpdates = [];
      }

      this.axios.put(this.serviceUrls.dailyRate.update(this, this.ratePlanId), updateMessages)
        .then((response) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showErrorMessage();
          this.showMessages(error.response);
        })
        .finally(() => {
          this.clearInterval(this.saveInterval);
          this.showUpdateModal = false;

          this.update = {
            startDate: this.startDate,
            endDate: this.endDate,
            roomTypeId: Object.entries(this.openRoomTypes)
              .filter(it => it[1])
              .map(it => it[0]) || [],
            daysOfWeek: [true, true, true, true, true, true, true],
            updates: {
              occupancy: {},
              extraAdult: {
                update: false,
                amount: null,
              },
              fewerAdult: {
                update: false,
                amount: null,
              },
              minAdultsForChildRate: {
                update: false,
                count: null,
              },
              childRate: {},
              derivedRateOffsets: {
                roomOffsetAmount: {
                  update: false,
                  type: 'RoomOffsetAmount',
                  amount: null,
                },
                roomOffsetPercentage: {
                  update: false,
                  type: 'RoomOffsetPercentage',
                  amount: null,
                },
                adultOffset: {
                  update: false,
                  type: 'AdultOffset',
                  amount: null,
                },
                childCategoryOffset: {},
              },
              restriction: {
                minLOS: {
                  update: false,
                  restriction: 'MinLOS',
                  value: null,
                },
                maxLOS: {
                  update: false,
                  restriction: 'MaxLOS',
                  value: null,
                },
                minStayThrough: {
                  update: false,
                  restriction: 'MinStayThrough',
                  value: null,
                },
                maxStayThrough: {
                  update: false,
                  restriction: 'MaxStayThrough',
                  value: null,
                },
                closed: {
                  update: false,
                  restriction: 'Bookable',
                  value: false, // inverted value
                },
                closedArrival: {
                  update: false,
                  restriction: 'ClosedArrival',
                  value: false,
                },
                closedDeparture: {
                  update: false,
                  restriction: 'ClosedDeparture',
                  value: false,
                },
                minLeadTimeToBook: {
                  update: false,
                  restriction: 'MinimumLeadTimeToBook',
                  value: null,
                },
                maxLeadTimeToBook: {
                  update: false,
                  restriction: 'MaximumLeadTimeToBook',
                  value: null,
                },
              },
            },
          };

          this.saving = false;
          this.setTimeout(() => this.loadData(), 500);
        });
    },
    getErrorFareClass(roomType, date, numPersons) {
      // 'daily-rate-editor__value--error'
      const rate = date.occupancyRate[numPersons] || this.getRate(roomType, date, numPersons);
      const perPersonRate = rate / numPersons;

      if (isNil(rate)) return '';
      if (rate < 0) return 'daily-rate-editor__value--error';

      if (numPersons > roomType.minOccupancy) {
        for (let i = (numPersons - 1); i >= roomType.minOccupancy; i--) {
          const occupancyRate = date.occupancyRate[i] || this.getRate(roomType, date, i);

          if (!isNil(occupancyRate) && occupancyRate > rate) return 'daily-rate-editor__value--error';

          if (!isNil(occupancyRate)) {
            const occupancyPerPersonRate = occupancyRate / i;
            if (occupancyPerPersonRate < perPersonRate) {
              return 'daily-rate-editor__value--warn';
            }
          }
        }
      }

      return '';
    },
    getRoomTypeAvailability(roomTypeId) {
      return this.dates.map((it) => {
        const date = it.replaceAll('-', '');
        if (!isNil(this.roomTypeAvailability) && !isNil(this.roomTypeAvailability.ByRoomType) && !isNil(this.roomTypeAvailability.ByRoomType[date])) {
          return this.roomTypeAvailability.ByRoomType[date].value[roomTypeId];
        } else {
          return this.roomTypeAvailability.ByRoomType;
        }
      });
    },
    onClickDate(date) {
      if (!isEmpty(date)) {
        this.update.startDate = date.replaceAll('-', '');
        this.update.endDate = date.replaceAll('-', '');
        this.showUpdateModal = true;
      }
    },
    onClickOpenModal() {
      this.update.startDate = this.startDate;
      this.update.endDate = this.endDate;
      this.showUpdateModal = true;
    },
    onFocusRoomTypes() {
      this.collapseLocked = true;
    },
    onBlurRoomTypes() {
      this.setTimeout(() => {
        this.collapseLocked = false;
      }, 500);
    },
    onMouseDown(date) {
      this.dateSelection.startDate = date;
      if (!isNil(this.dateSelection.timeout)) {
        this.clearTimeout(this.dateSelection.timeout);
        this.dateSelection.timeout = null;
      }
      this.dateSelection.timeout = this.setTimeout(() => {
        this.dateSelection.startDate = null;
        this.dateSelection.endDate = null;
        this.dateSelection.timeout = null;
      }, 5000);
    },
    onMouseMove(date) {
      if (!isNil(this.dateSelection.startDate)) {
        this.dateSelection.endDate = date;

        if (!isNil(this.dateSelection.endDate) && this.dateSelection.endDate < this.dateSelection.startDate) {
          this.cancelSelection();
        }
      }
    },
    cancelSelection() {
      if (!isNil(this.dateSelection.timeout)) {
        this.clearTimeout(this.dateSelection.timeout);
        this.dateSelection.startDate = null;
        this.dateSelection.endDate = null;
        this.dateSelection.timeout = null;
      }
    },
    onMouseUp(date) {
      if (!isNil(this.dateSelection.startDate)) {
        if (!isNil(this.dateSelection.timeout)) {
          this.clearTimeout(this.dateSelection.timeout);
          this.dateSelection.timeout = null;
        }
        this.dateSelection.endDate = date;

        if (!isNil(this.dateSelection.endDate) && this.dateSelection.endDate < this.dateSelection.startDate) {
          this.cancelSelection();
        }

        this.update.startDate = this.dateSelection.startDate;
        this.update.endDate = this.dateSelection.endDate;
        this.showUpdateModal = true;
      }
      this.dateSelection.startDate = null;
      this.dateSelection.endDate = null;
      this.dateSelection.timeout = null;
    },
    editInline(ratePlan, roomType, date, type, param1 = null, param2 = null) {
      this.completeInlineEditing();

      this.currentEdit.ratePlanId = ratePlan.id;
      this.currentEdit.roomTypeId = roomType.id;
      this.currentEdit.date = date.date;
      this.currentEdit.type = type;
      this.currentEdit.param1 = param1;
      this.currentEdit.param2 = param2;

      switch (type) {
        case 'occupancyRate':
          this.currentEdit.value = date.occupancyRate[param1];
          if (isNil(this.currentEdit.value)) {
            this.currentEdit.value = this.getRate(roomType, date, param1);
          }
          break;
        case 'extraAdultRate':
          this.currentEdit.value = date.extraAdultRate || null;
          break;
        case 'fewerAdultRate':
          this.currentEdit.value = date.fewerAdultRate || null;
          break;
        case 'childCategoryRate':
          if (!isNil(date.childCategoryRate)) {
            this.currentEdit.value = date.childCategoryRate[param1] || null;
          }
          break;
        case 'rateOffsets':
          if (!isNil(date.rateOffsets)) {
            this.currentEdit.value = date.rateOffsets[param1] || null;
          }
          // perAdultOffset
          // roomOffsetPercentage
          // roomOffsetAmount
          break;
        case 'childCategoryOffset':
          if (!isNil(date.rateOffsets.childCategoryOffset)) {
            this.currentEdit.value = date.rateOffsets.childCategoryOffset[param1] || null;
          }
          break;
        case 'MinLOS':
        case 'MaxLOS':
        case 'MinStayThrough':
        case 'MaxStayThrough':
          this.currentEdit.value = this.getValue(ratePlan, roomType, date, type);
          break;
        default:
          // do nothing
          break;
      }

      this.currentEdit.active = true;

      this.$nextTick(() => {
        try {
          this.$el.querySelector('.input__inline-editing input').select();
        } catch (ignore) { /* ignore */ }
      });
    },
    completeInlineEditing() {
      if (this.currentEdit.active) {
        this.inlineEditQueue.push(this.currentEdit);
        this.processInlineEditQueue();
        this.currentEdit = {
          active: false,
          ratePlanId: null,
          roomTypeId: null,
          date: null,
          type: null,
          param1: null,
          param2: null,
          value: null,
        };
      }
    },
    processInlineEditQueue() {
      const item = this.inlineEditQueue.shift();
      if (!isNil(item)) {
        const updateMessage = {
          startDate: item.date,
          endDate: item.date,
          roomTypeId: item.roomTypeId,
          daysOfWeek: [true, true, true, true, true, true, true],
          occupancyRateUpdates: [],
          childRateUpdates: [],
          restrictionUpdates: [],
          dayRateOffsetUpdates: [],
        };

        switch (item.type) {
          case 'extraAdultRate':
            updateMessage.extraAdultRateUpdate = {
              amount: item.value,
            };
            break;
          case 'fewerAdultRate':
            updateMessage.fewerAdultRateUpdate = {
              amount: item.value,
            };
            break;
          case 'childCategoryRate':
            updateMessage.childRateUpdates = [
              {
                ageCategoryId: item.param1,
                amount: item.value,
              },
            ];
            break;
          case 'occupancyRate':
            if (isNil(item.value) || item.value >= 0) {
              updateMessage.occupancyRateUpdates = [
                {
                  occupancy: item.param1,
                  amount: item.value,
                },
              ];
            }
            break;
          case 'rateOffsets':
            switch (item.param1) {
              case 'perAdultOffset':
                updateMessage.dayRateOffsetUpdates = [
                  {
                    type: 'AdultOffset',
                    id: null,
                    amount: item.value,
                  },
                ];
                break;
              case 'roomOffsetPercentage':
                updateMessage.dayRateOffsetUpdates = [
                  {
                    type: 'RoomOffsetPercentage',
                    id: null,
                    amount: item.value,
                  },
                ];
                break;
              case 'roomOffsetAmount':
                updateMessage.dayRateOffsetUpdates = [
                  {
                    type: 'RoomOffsetAmount',
                    id: null,
                    amount: item.value,
                  },
                ];
                break;
              default:
                // ignore
                break;
            }
            break;
          case 'childCategoryOffset':
            updateMessage.dayRateOffsetUpdates = [
              {
                type: 'ChildCategoryOffset',
                id: item.param1,
                amount: item.value,
              },
            ];
            break;
          case 'MinLOS':
          case 'MaxLOS':
          case 'MinStayThrough':
          case 'MaxStayThrough':
            if (isNil(item.value) || (item.value >= 0 && item.value <= 365)) {
              updateMessage.restrictionUpdates = [
                {
                  restriction: item.type,
                  value: item.value,
                },
              ];
            }
            break;
          default:
            // handle error;
            break;
        }

        this.axios.put(this.serviceUrls.dailyRate.update(this, item.ratePlanId), updateMessage)
          .then((response) => {
            this.showSuccessMessage();
          })
          .catch((error) => {
            this.showErrorMessage();
            this.showMessages(error.response);
          })
          .finally(() => {
            this.setTimeout(() => this.reloadDate(item.date), 500);
          });

        this.processInlineEditQueue();
      }
    },
    getValue(ratePlan, roomType, date, restriction) {
      switch (restriction) {
        case 'MinLOS':
          return date.restrictions.minLOS || this.getParentValue(ratePlan, roomType, date, restriction) || null;
        case 'MaxLOS':
          if (ratePlan.ratePlanType === 'Package' && isNil(date.restrictions.maxLOS) && (isNil(date.parentRestrictions) || isNil(date.parentRestrictions.maxLOS)) && (!isNil(date.restrictions.minLOS) || (!isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minLOS)))) {
            return this.getValue(ratePlan, roomType, date, 'MinLOS') || null;
          } else {
            // don't OR with NULL, because otherwise 0 will be modified into NULL
            return this.coalesce(date.restrictions.maxLOS, this.getParentValue(ratePlan, roomType, date, restriction));
          }
        case 'MinStayThrough':
          return date.restrictions.minStayThrough || this.getParentValue(ratePlan, roomType, date, restriction) || null;
        case 'MaxStayThrough':
          if (ratePlan.ratePlanType === 'Package' && isNil(date.restrictions.maxStayThrough) && (isNil(date.parentRestrictions) || isNil(date.parentRestrictions.maxStayThrough)) && (!isNil(date.restrictions.minStayThrough) || (!isNil(date.parentRestrictions) && !isNil(date.parentRestrictions.minStayThrough)))) {
            return this.getValue(ratePlan, roomType, date, 'MinStayThrough') || null;
          } else {
            // don't OR with NULL, because otherwise 0 will be modified into NULL
            return this.coalesce(date.restrictions.maxStayThrough, this.getParentValue(ratePlan, roomType, date, restriction));
          }
        case 'MaximumLeadTimeToBook':
          return date.restrictions.maxLeadTimeToBook || this.getParentValue(ratePlan, roomType, date, restriction) || null;
        case 'MinimumLeadTimeToBook':
          return date.restrictions.minLeadTimeToBook || this.getParentValue(ratePlan, roomType, date, restriction) || null;
        default:
          return null;
      }
    },
    getParentValue(ratePlan, roomType, date, restriction) {
      if (isNil(date.parentRestrictions)) return null;
      switch (restriction) {
        case 'MinLOS':
          return date.parentRestrictions.minLOS || null;
        case 'MaxLOS':
          return date.parentRestrictions.maxLOS; // don't OR with NULL, because otherwise 0 will be modified into NULL
        case 'MinStayThrough':
          return date.parentRestrictions.minStayThrough || null;
        case 'MaxStayThrough':
          return date.parentRestrictions.maxStayThrough; // don't OR with NULL, because otherwise 0 will be modified into NULL
        case 'MaximumLeadTimeToBook':
          return date.parentRestrictions.maxLeadTimeToBook || null;
        case 'MinimumLeadTimeToBook':
          return date.parentRestrictions.minLeadTimeToBook || null;
        default:
          return null;
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .overbooking {
    background-color: rgba($error, 0.3)!important;
  }

  .daily-rate-editor {
    &__pane {
      width: 100%;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 6fr 6fr;
      background-color: $lightmiddlegray;
      grid-gap: 1px;
      @media (min-width: $br-tablet) {
        grid-template-columns: 4fr 8fr;
      }
      @media (min-width: $br-desktop) {
        grid-template-columns: 3fr 10fr;
      }
      @media (min-width: $br-hd) {
        grid-template-columns: 2fr 10fr;
      }
    }
    &__scroll {
      display: flex;
      width: 100%;
      height: auto;
      overflow: auto;
    }
    &__wrapper, &__left {
      display: grid;
      grid-auto-rows: 4rem;
      grid-template-rows: 1rem 9rem;
      grid-gap: 1px;
      width: 100%;
    }
    &__wrapper {
      grid-template-columns: repeat(var(--days), minmax(7.5rem, 1fr));
      overflow-y: hidden;
    }
    &__left {
      grid-template-columns: 1fr;
      min-width: 0;
      > * {
        min-width: 0;
      }
    }
    &__roomType {
      font-weight: bold;
      padding-left: 1rem;
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      background-color: $roomplan-lightgray;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__label {
      min-width: 0;
      padding-right: 1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 3rem;
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      background-color: white;
      &--sub-heading {
        padding-left: 2rem;
        font-weight: bold;
      }
      &--2 {
        padding-left: 5rem;
      }
      &--right {
        display: flex;
        padding: 0.5rem;
        align-items: center;
        height: 100%;
        width: 100%;
        color: $middlegray;
        font-weight: bold;
        text-align: center;
        justify-items: center;
        justify-content: center;
        justify-self: center;
        white-space: nowrap;
      }
      &__wrapper {
        display: grid;
        grid-template-columns: auto 6rem;
        background-color: white;
      }
    }
    &__date {
      text-align: center;
      background-color: $roomplan-lightgray;
      font-weight: bold;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(4, 1fr);
      align-items: center;
      grid-gap: 1px;
      position: relative;
      //writing-mode: vertical-rl;
      //text-orientation: mixed;
      &--weekend {
        background-color: darken($lightgray,1%);
      }

      &:not(&--inline-editing) {
        &:after {
          content: ' ';
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: -25000vh;
          width: 100%;
          cursor: pointer;
        }
        &:hover:after {
          background: rgba($middlemint,.15);
        }
        &.in-selection:after {
          background: rgba($middlemint,.15);
        }
      }
    }
    &__value, &__placeholder {
      overflow: hidden;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: right;
      text-align: right;
      padding: 0.4rem;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr;
    }
    &__input {
      overflow: hidden;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: right;
      text-align: right;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr;
      background: white;

      &.daily-rate-editor__value--inherited {
        grid-template-rows: 5fr 2fr;
      }
    }
    &__inherited-value {
      background-color: $lightgray;
      font-size: 80%;
      margin-left: -0.4rem;
      margin-right: -0.4rem;
      margin-bottom: -0.4rem;
      padding-left: 0.4rem;
      padding-right: 0.4rem;
      padding-top: 0.2rem;
    }
    &__value {
      background-color: white;
      &--inherited {
        grid-template-rows: 5fr 2fr;
      }
      &--auto {
        background-color: lighten($yellowFull, 30%);
      }
      &--warn {
        background-color: lighten($blue, 30%);
      }
      &--error {
        background-color: lighten($error, 30%);
      }
      &--inline-editing {
        cursor: text;
        z-index: 2;
      }
    }
    &__placeholder {
      background-color: $roomplan-lightgray;
      &--weekend {
        background-color: darken($lightgray,1%);
      }
    }
    &__icon {
      min-width: 3rem!important;
      width: 3rem!important;
      max-width: 3rem!important;
      &--open {
        transform: rotate(180deg);
      }
    }
    &__legend {
      box-shadow: 0.1rem 0.1rem 0.2rem 0 rgba($black,0.5);
      padding-bottom: 100%;

      &--auto {
        background-color: lighten($yellowFull, 30%);
      }
      &--warn {
        background-color: lighten($blue, 30%);
        color: white;
      }
      &--error {
        background-color: lighten($error, 30%);
        color: white;
      }

      &__item {
        display: grid;
        grid-template-columns: 30px 1fr;
        grid-template-rows: auto;
        grid-column-gap: 1rem;
        margin-bottom: 1rem;
      }
      &__label {
        align-self: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageDayRateEditor.vue